const RETURN_TO_KEY = 'returnTo';

// Only same-origin relative paths; '//host' and '/\host' would be open redirects
const isSafePath = (path: string): boolean =>
  path.startsWith('/') && !path.startsWith('//') && !path.startsWith('/\\');

// Remember where the user was heading before being sent to Google login
export const saveReturnTo = (path: string): void => {
  if (path === '/' || path.startsWith('/login') || !isSafePath(path)) {
    return;
  }
  sessionStorage.setItem(RETURN_TO_KEY, path);
};

// One-shot: returns the saved path (if safe) and clears it
export const consumeReturnTo = (): string | null => {
  const path = sessionStorage.getItem(RETURN_TO_KEY);
  sessionStorage.removeItem(RETURN_TO_KEY);
  return path && isSafePath(path) ? path : null;
};
